import React from 'react';
import GenericCrudPage from '../../../components/Generic/GenericCrudPage';
import { SessionEdit, SessionReadOnly } from './SessionForm';
import dayjs from 'dayjs';

function SessionsPage({}: any) {
  return (
    <GenericCrudPage
      key='sessions-page'
      tableColumns={[
        {
          field: 'title',
          headerName: 'Title',
          width: 200,
        },
        {
          field: 'speaker',
          headerName: 'Speaker',
          width: 200,
        },
      ]}
      singularName='Session'
      pageTitle='Sessions'
      resource='sessions'
      allowAdd={true}
      allowEdit={true}
      allowDelete={true}
      ReadOnlyComponent={SessionReadOnly}
      EditFormComponent={SessionEdit}
      newPayload={{
        title: '',
        speaker: '',
        floorplan: '',
        venue: '',
        description: '',
        start: dayjs(),
        end: dayjs(),
      }}
      validateFn={(data: any) => {
        return [true, []];
      }}
    />
  );
}

export default SessionsPage;
